/**
 * Milestones timeline section
 */

import React from "react";
import parse from "html-react-parser";
import { kebabCase } from "lodash";
import "../styles/bg-page-circles.css";
import CopyLinkButton from "./copy-link-button";

const Milestones = ({ props, annualReport }) => {
  return (
    <section
      className={`section m-section bg-page-circle bg-page-circles`}
      key={props.heading || props.includeInStickyMenu?.menuTitle}
    >

      <div className={`relative ${annualReport ? "" : "container"}`}>
        <div className={`${annualReport ? "mx-auto relative 2xl:container" : "lg:w-2/3 mx-auto"}`}>
          <div className={annualReport ? "" : ""}>
            <div className="group-copy-link group grid grid-cols-1 justify-start text-center">
              {props.heading ? (
                <>
                  <h2 className={`anchor-heading mb-10`} id={kebabCase(props.heading).replace(/[0-9]/g, '')}>
                    {props.heading}
                  </h2>
                  <CopyLinkButton heading={props.heading} />
                </>
              ) : props.includeInStickyMenu?.menuTitle ? (
                <div id={kebabCase(props.includeInStickyMenu.menuTitle) || ""}>
                  <CopyLinkButton heading={props.includeInStickyMenu.menuTitle} className="top-0 left-0" />
                </div>
              ) : null}
            </div>

          </div>
          <div className={annualReport ? "overflow-y-auto px-12" : "flow-root"}>
            <ol className={annualReport ? "grid grid-flow-col print:block w-auto" : ""}>
              {props.year?.map((year) => {
                return (
                  <li key={`${kebabCase(year.year) || ""}`} className={annualReport ? "w-48 last-of-type:w-60 last-of-type:pr-12" : null}>
                    <div className={annualReport ? "" : "grid grid-cols-4 gap-y-6 gap-x-3 sm:gap-x-6"}>
                      {year.year ? (
                        <div
                          className={`font-bold text-xl ${annualReport ? "text-left print:mt-4 ml-2" : "text-right print:text-left print:mt-8"}`}
                          data-sal={annualReport ? "slide-right" : "slide-down"} data-sal-delay="100"
                        >
                          {year.link ? (
                            <a className="btn-sm btn-gray" href={year.link.url} target={year.link.target}>
                              {year.year}
                            </a>
                          ) : (
                            <div className={`py-1 ${annualReport === "2023" ? "" : "px-3"}`}>{year.year}</div>
                          )}
                        </div>
                      ) : null}

                      <div className={`relative pb-8 ${annualReport ? "" : "col-span-3"}`}>
                        {annualReport ? null : <span
                          className="absolute top-1 left-1.5 -ml-px h-full w-0.5 bg-blue mt-4"
                          aria-hidden="true"
                        ></span>}
                        <div className="relative flex space-x-3">

                          {annualReport === "2023" ? null : <span
                            className={`h-3 w-3 flex rounded-full bg-blue ring-8 ring-white absolute ${annualReport ? "-left-1 -mt-1" : "-top-1 left-0 mt-4"}`}
                            aria-hidden
                          ></span>}

                          <div className={`min-w-0 flex-1  ${annualReport === "2023" ? "relative pl-2 pt-2" : annualReport ? "border-t-2 border-blue pl-2 pt-1.5" : "pl-3 pt-1.5"}`}
                          >
                            {annualReport === "2023" ? <span aria-hidden className="h-[4px] bg-gradient-to-r from-blue-300 to-blue-50 w-full absolute inset-x-0 top-0"></span> : null}
                            {year.milestones ? (
                              <div
                                className="parsed-content"

                              >
                                {parse(year.milestones)}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
          {annualReport ? <>
            <div aria-hidden className="pointer-events-none absolute right-0 2xl:right-8 inset-y-0 bg-gradient-to-l from-white w-12"></div>
            <div aria-hidden className="pointer-events-none absolute left-0 2xl:left-8 inset-y-0 bg-gradient-to-r from-white w-12"></div>
          </> : null}
        </div>
      </div>
    </section>
  );
};

export default Milestones;
